export class ResetPasswordConfirmDTO {
    uid: string;
    token: string;
    new_password1: string;
    new_password2: string;

    constructor(data: any) {
        this.uid = data.uid;
        this.token = data.token;
        this.new_password1 = data.new_password1;
        this.new_password2 = data.new_password2;
    }
}
